import * as i1 from '@upr-web-primer/app-utils';
import { param } from '@upr-web-primer/app-utils';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { NgModule, Injectable, Inject } from '@angular/core';
import { WindowModule, WINDOW } from '@upr-web-primer/window';
import { HttpHeaders } from '@angular/common/http';
import * as i5 from '@angular/router';
import * as i2 from '@upr-web-primer/dal';
import * as i6 from '@upr-web-primer/ms-guests';
import * as i7 from '@upr-web-primer/notification';
import * as i8 from '@upr-web-primer/page-labels';
import * as i3 from '@upr-web-primer/spinner';
import * as i9 from '@upr-web-primer/storage';
import { get } from 'lodash-es';
import * as i4 from 'ngx-cookie-service';
import { BehaviorSubject } from 'rxjs';
const FNBO_REPLACED_DEFAULTS = {
  fnbo: {
    cookies_domain: param('$fnbo.cookiesDomain$') || param('$fnbo.cookies_domain$'),
    agent_bank: param('$fnbo.agentBank$') || param('$fnbo.agent_bank$'),
    cookie_expiry_duration_days: param('$fnbo.cookie_expiry_duration$'),
    host_url: param('$fnbo.host_rul$')
  }
};
const FNBO_ENV_DEFAULTS = {
  fnbo: {
    cookies_domain: '.universalorlando.com',
    agent_bank: 'UFL',
    cookie_expiry_duration_days: '7',
    host_url: 'https://www.firstbankcard.com'
  }
};
const relativeUrls = {
  MS_CARD_PROMOTIONS: '/resort-areas/{resort-area-code}/validate-visa-eligibility',
  FNBO_PAYMENT_TOKENS: '/fnbo-customer-session-ID/{customer-session-id}/payment-tokens',
  FNBO_ADD_TO_WALLET: '/guests/{guest-id}/fnbo-add-to-wallet',
  FNBO_PREFILL: '/fnbo-prefill',
  FNBO_PREFILL_CONFIGURATIONS: '/fnbo-prefill-configurations/{partner-marketing-code}',
  GET_BILLING_ADDRESS: '/fnbo-customer-session-id/{customer-session-id}/billing-details?include-payment-tokens={include-payment-tokens}',
  FNBO_TERMS_AND_CONDITIONS: '/lynx/#/soct/{short_code}'
};
class CardPromotionModule {
  static {
    this.ɵfac = function CardPromotionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CardPromotionModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CardPromotionModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, WindowModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardPromotionModule, [{
    type: NgModule,
    args: [{
      declarations: [],
      imports: [CommonModule, WindowModule],
      exports: []
    }]
  }], null, null);
})();
var ActionTypes;
(function (ActionTypes) {
  ActionTypes["INIT"] = "init";
  ActionTypes["INIT_CONFIRMATION"] = "init-confirmation";
  ActionTypes["CANCEL_CONFIRMATION"] = "close";
  ActionTypes["SAVE_TO_WALLET"] = "save-to-wallet";
  ActionTypes["TERMS_AND_CONDITIONS"] = "toc";
})(ActionTypes || (ActionTypes = {}));
var CardTypes;
(function (CardTypes) {
  CardTypes["FEE_BASED"] = "fee_based";
  CardTypes["NON_FEE_BASED"] = "non_fee_based";
})(CardTypes || (CardTypes = {}));
function getQueryParamsFromURL(activatedRoute) {
  const queryParams = {};
  activatedRoute.queryParams.subscribe(params => {
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        queryParams[key] = params[key];
      }
    }
  });
  return Object.keys(queryParams).length ? queryParams : {};
}
class CardPromotionService {
  constructor(defaultValues, window, appEnvSrv, dal, spinner, cookieService, route, guestService, notification, pageLabelsService, localStorage) {
    this.defaultValues = defaultValues;
    this.window = window;
    this.appEnvSrv = appEnvSrv;
    this.dal = dal;
    this.spinner = spinner;
    this.cookieService = cookieService;
    this.route = route;
    this.guestService = guestService;
    this.notification = notification;
    this.pageLabelsService = pageLabelsService;
    this.localStorage = localStorage;
    this.loadConfirmationModal$ = new BehaviorSubject(null);
    this.closeConfirmationModal$ = new BehaviorSubject(false);
    this.shoppingCartId$ = new BehaviorSubject(null);
    if (this.pageLabelsService) {
      this.pageLabelsService.get().then(data => this.pageLabels = data);
    }
    this.appEnvSrv.addDefaultValues(FNBO_ENV_DEFAULTS, FNBO_REPLACED_DEFAULTS);
    this.fnboEnvDefaults = this.appEnvSrv.getEnvVariables('fnbo');
  }
  replaceURITokens(url, tokenValuePairs) {
    return tokenValuePairs.reduce((transformedUrl, tokenValuePair) => {
      const [token, value] = tokenValuePair;
      return transformedUrl.replace(token, value);
    }, url);
  }
  /**
   * Handles button actions based on the provided custom event detail.
   * @param customEventDetail - An object containing the details of the custom event, including the action type.
   */
  buttonActionHandler(customEventDetail) {
    if (!customEventDetail) {
      return;
    }
    const queryParams = getQueryParamsFromURL(this.route);
    const customerSessionId = get(queryParams, 'customer-session-id') || this.guestService.helper.getInstanceId() || '';
    if (customEventDetail?.action === ActionTypes.INIT && !customEventDetail.url) {
      this.initPrefillRequest(customEventDetail);
      return;
    }
    if (!!customEventDetail?.showConfirmationModal) {
      this.loadConfirmationModal$.next(customEventDetail);
      return;
    }
    switch (customEventDetail?.action) {
      case ActionTypes.INIT:
        const newWindow = window.open(customEventDetail?.url, customEventDetail?.target || '_self');
        this.popupBlockerHandler(newWindow);
        break;
      case ActionTypes.SAVE_TO_WALLET:
        this.fnboAddToWallet({
          customer_session_id: customerSessionId
        });
        break;
      case ActionTypes.TERMS_AND_CONDITIONS:
        this.termsAndConditions(customEventDetail);
        break;
    }
  }
  async termsAndConditions(customEventDetail) {
    const target = get(customEventDetail, 'target', '_self');
    if (customEventDetail?.url) {
      const newWindow = this.window.open(customEventDetail.url, target);
      this.popupBlockerHandler(newWindow);
      return;
    }
    const secureBaseUrl = get(this.defaultValues, 'SECURE_API_BASEURL', '');
    const queryParams = getQueryParamsFromURL(this.route);
    const partnerMarketingCode = get(queryParams, 'partnerMarketingCode', '');
    const marketingCode = partnerMarketingCode || customEventDetail?.partnerMarketingCode;
    const fnboPrefillConfigurations = this.replaceURITokens(relativeUrls.FNBO_PREFILL_CONFIGURATIONS, [['{partner-marketing-code}', marketingCode || '']]);
    return this.dal.httpRequest(fnboPrefillConfigurations, 'GET', {}, undefined, undefined, undefined, undefined, !!secureBaseUrl ? secureBaseUrl : undefined).then(response => {
      let shortCode;
      if (customEventDetail?.cardType === CardTypes.FEE_BASED) {
        shortCode = response.short_code_fee_based;
      } else if (customEventDetail?.cardType === CardTypes.NON_FEE_BASED) {
        shortCode = response.short_code_non_fee_based;
      }
      const termsUrl = this.replaceURITokens(this.fnboEnvDefaults.host_url + relativeUrls.FNBO_TERMS_AND_CONDITIONS, [['{short_code}', shortCode || '']]);
      customEventDetail.url = termsUrl;
      const newWindow = this.window.open(termsUrl, target);
      this.popupBlockerHandler(newWindow, customEventDetail);
    });
  }
  validateCard(cardInfo) {
    const secureBaseUrl = get(this.defaultValues, 'SECURE_API_BASEURL', '');
    this.relativeUrl = this.replaceURITokens(relativeUrls.MS_CARD_PROMOTIONS, [['{resort-area-code}', this.defaultValues.RESORT_AREA_CODE || this.defaultValues.PERSONALIZE_RESORT_CODE]]);
    this.spinner.show();
    return this.dal.httpRequest(this.relativeUrl, 'POST', cardInfo, undefined, undefined, undefined, undefined, !!secureBaseUrl ? secureBaseUrl : undefined).then(response => {
      return response;
    });
  }
  /**
   * Initiates a prefill request to obtain a unique application URL for the current guest.
   * @param request - The request payload containing details required to initiate the prefill request.
   */
  async getPrefillAppRoute(request) {
    this.spinner.show();
    const secureBaseUrl = get(this.defaultValues, 'SECURE_API_BASEURL', '');
    try {
      const response = await this.dal.httpRequest(relativeUrls.FNBO_PREFILL, 'POST', request, undefined, undefined, undefined, undefined, secureBaseUrl || undefined);
      return response;
    } catch (error) {
      throw error;
    } finally {
      this.spinner.hide();
    }
  }
  /**
   * Displays an message to the user using the notification service.
   * @param message - The message string that needs to be displayed to the user.
   * @param type - The message type success or error message.
   */
  showMessage(message, type) {
    this.notification.show(message, type);
  }
  /**
   * Initializes a prefill request based on the provided custom event detail.
   * @param customEventDetail - An object containing the custom event details required for constructing the prefill request.
   */
  async initPrefillRequest(customEventDetail) {
    const {
      route,
      localStorage,
      guestService,
      pageLabels
    } = this;
    const queryParams = getQueryParamsFromURL(route);
    const partnerMarketingCode = get(queryParams, 'partnerMarketingCode', '');
    this.closeConfirmationModal$.next(true);
    const instanceId = localStorage.getItem('instance_id') || guestService.helper.getInstanceId() || '';
    const customerLoginId = guestService.helper.isLoggedIn() ? guestService.helper.getOAuthGuestID() : undefined;
    const {
      cardType,
      partnerMarketingCode: eventPartnerMarketingCode
    } = customEventDetail;
    const cartId = this.shoppingCartId$.getValue() || undefined;
    const request = {
      user_card_selection: cardType,
      customer_session_id: instanceId,
      customer_login_id: customerLoginId,
      package_cart_id: cartId,
      partner_marketing_code: partnerMarketingCode || eventPartnerMarketingCode,
      agent_bank: this.fnboEnvDefaults.agent_bank
    };
    try {
      const response = await this.getPrefillAppRoute(request);
      if (response?.application_url) {
        customEventDetail.url = response.application_url;
        this.loadConfirmationModal$.next(customEventDetail);
      }
    } catch (error) {
      console.error('Error during the prefill request:', error);
      const message = error?.status === 422 ? get(pageLabels, 'upr.com.cobrand_prefill_422_error_message') || pageLabels?.ER71 : pageLabels?.ER71;
      this.showMessage(message, 'error');
    }
  }
  fnboAddToWallet(addToWalletRequest) {
    if (!addToWalletRequest?.customer_session_id) {
      return Promise.reject('Invalid request');
    }
    const guestId = this.guestService.helper.getGuestId();
    if (!guestId) {
      return Promise.reject('Missing guest id');
    }
    this.closeModal();
    const secureBaseUrl = get(this.defaultValues, 'SECURE_API_BASEURL', '');
    const requestUrl = this.replaceURITokens(relativeUrls.FNBO_ADD_TO_WALLET, [['{guest-id}', guestId || '']]);
    const requestBody = {
      customer_session_id: addToWalletRequest.customer_session_id
    };
    //using the same sourceId we are using for card operations in guest account
    const sourceId = this.guestService.helper.getSourceId('WebCard') || '';
    const headers = new HttpHeaders().append('x-source-id', sourceId);
    return this.dal.httpRequest(requestUrl, 'POST', requestBody, headers, undefined, undefined, true, !!secureBaseUrl ? secureBaseUrl : undefined).then(response => {
      this.showMessage(this.pageLabels?.SU9, 'success');
      return response;
    }).catch(error => {
      this.showMessage(this.pageLabels?.ER71 || error, 'error');
    });
  }
  getBillingAddress(includePaymentTokens = false) {
    const secureBaseUrl = get(this.defaultValues, 'SECURE_API_BASEURL', '');
    const queryParams = getQueryParamsFromURL(this.route);
    const customerSessionId = get(queryParams, 'customer-session-id') || this.cookieService.get('FNBO-Customer-Session-Id') || this.localStorage.getItem('instance_id') || this.guestService.helper.getInstanceId();
    const isReturnAfterApplication = !!queryParams['customer-session-id'];
    const getBillingAddressUrl = this.replaceURITokens(relativeUrls.GET_BILLING_ADDRESS, [['{customer-session-id}', customerSessionId || ''], ['{include-payment-tokens}', String(includePaymentTokens)]]);
    return this.dal.httpRequest(getBillingAddressUrl, 'GET', {}, undefined, undefined, undefined, undefined, !!secureBaseUrl ? secureBaseUrl : undefined).then(response => {
      if (!response) {
        return Promise.reject('No response');
      }
      const paymentTokens = get(response, 'payment_tokens');
      if (!paymentTokens) {
        return response;
      }
      if (isReturnAfterApplication) {
        this.setFnboApprovalCookie(paymentTokens, customerSessionId);
      }
      return response;
    });
  }
  setFnboApprovalCookie(paymentTokens, customerSessionId) {
    this.setCookie('FNBO-Customer-Session-Id', customerSessionId);
    const aciToken = get(paymentTokens, 'aci_token');
    if (aciToken) {
      this.setCookie('FNBO-Payment', 'true');
    }
    const elavonToken = get(paymentTokens, 'elavon_token');
    if (elavonToken) {
      this.setCookie('FNBO-Payment-Hotel', 'true');
    }
    const cybersourceToken = get(paymentTokens, 'cybersource_token');
    if (cybersourceToken) {
      this.setCookie('FNBO-Payment-Packages', 'true');
    }
  }
  setCookie(key, value) {
    const standardCookieLife = new Date();
    const defaultCookieExpiryDays = +this.fnboEnvDefaults.cookie_expiry_duration_days || 7;
    standardCookieLife.setDate(standardCookieLife.getDate() + defaultCookieExpiryDays);
    this.cookieService.set(key, value, standardCookieLife, '/', this.fnboEnvDefaults.cookies_domain);
  }
  closeModal() {
    const modalElement = document.querySelector('gds-modal');
    if (modalElement) {
      document.body.style.overflow = 'visible';
      modalElement.dispatchEvent(new Event('modalClose'));
    }
  }
  popupBlockerHandler(popup, customEventDetail) {
    if (!popup || popup?.closed || typeof popup?.closed == 'undefined') {
      console.error('popup blocker is active');
      const modalElement = document.querySelector('gds-modal');
      if (!modalElement) {
        customEventDetail.showConfirmationModal = true;
        this.loadConfirmationModal$.next(customEventDetail);
      }
      return;
    } else {
      this.closeModal();
    }
  }
  static {
    this.ɵfac = function CardPromotionService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CardPromotionService)(i0.ɵɵinject('DefaultValues'), i0.ɵɵinject(WINDOW), i0.ɵɵinject(i1.AppEnvironmentService), i0.ɵɵinject(i2.DalService), i0.ɵɵinject(i3.SpinnerService), i0.ɵɵinject(i4.CookieService), i0.ɵɵinject(i5.ActivatedRoute), i0.ɵɵinject(i6.MsGuestsService), i0.ɵɵinject(i7.NotificationService), i0.ɵɵinject(i8.PageLabelsResolver), i0.ɵɵinject(i9.LocalStorageService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CardPromotionService,
      factory: CardPromotionService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardPromotionService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['DefaultValues']
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [WINDOW]
    }]
  }, {
    type: i1.AppEnvironmentService
  }, {
    type: i2.DalService
  }, {
    type: i3.SpinnerService
  }, {
    type: i4.CookieService
  }, {
    type: i5.ActivatedRoute
  }, {
    type: i6.MsGuestsService
  }, {
    type: i7.NotificationService
  }, {
    type: i8.PageLabelsResolver
  }, {
    type: i9.LocalStorageService
  }], null);
})();

/*
 * Public API Surface of card-promotion
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CardPromotionModule, CardPromotionService, FNBO_ENV_DEFAULTS, getQueryParamsFromURL, relativeUrls };
